import React, { ComponentType, Dispatch, SetStateAction, useEffect, useState } from 'react';

import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { SuccessActionsDialog } from 'components/Dialogs/SuccessActionsDialog/SuccessActionsDialog';

export interface ComponentWithSuccessActionsDialogProps {
  setSuccessActionMessages: Dispatch<SetStateAction<string[]>>;
}

export const withSuccessActionsDialog =
  <T,>(Component: ComponentType<T & ComponentWithSuccessActionsDialogProps>) =>
  (props: T): JSX.Element => {
    const [successActionMessages, setSuccessActionMessages] = useState<string[]>([]);

    const handleResetMessages = () => setSuccessActionMessages([]);

    useEffect(() => handleResetMessages, []);

    return (
      <>
        <Component {...props} setSuccessActionMessages={setSuccessActionMessages} />
        <SuccessActionsDialog
          open={!isEmpty(successActionMessages)}
          onClose={handleResetMessages}
          messages={successActionMessages}
        />
      </>
    );
  };

export const withSuccessActionsDialogProps = {
  setSuccessActionMessages: PropTypes.func.isRequired,
};
